import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={54}
    height={54}
    fill="none"
    {...props}
  >
    <circle cx={27} cy={27} r={27} fill="#FFF8DD" />
    <g opacity={0.5}>
      <path
        fill="url(#AssetCircle_svg__a)"
        d="m27.598 37.83 5.85-6.483a.96.96 0 0 1 1.413-.014l6.099 6.494c.11.118.027.311-.135.311h-13.09a.184.184 0 0 1-.137-.308"
      />
      <path
        fill="url(#AssetCircle_svg__b)"
        d="m13.067 37.63 10.058-11.145a1.28 1.28 0 0 1 1.883-.019l10.48 11.16a.31.31 0 0 1-.226.522H13.297a.31.31 0 0 1-.23-.518"
      />
      <circle
        cx={34.152}
        cy={18.845}
        r={2.992}
        fill="url(#AssetCircle_svg__c)"
      />
    </g>
    <defs>
      <linearGradient
        id="AssetCircle_svg__a"
        x1={38.639}
        x2={21.243}
        y1={36.129}
        y2={35.461}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="AssetCircle_svg__b"
        x1={31.593}
        x2={2.402}
        y1={34.776}
        y2={33.656}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="AssetCircle_svg__c"
        x1={36.022}
        x2={28.542}
        y1={20.248}
        y2={20.092}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetCircle;
